import { Search as SearchIcon } from '@mui/icons-material';
import { Avatar, CardHeader, CardHeaderProps, Divider } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';

import AutosuggestChipInput, { Properties as AutosuggestProps } from '@/components/chip-filter/autosuggest-chip-input';

const useStyles = makeStyles()((theme) => ({
  action: {
    marginTop: 0,
    alignSelf: 'normal',
    display: 'flex',
    alignItems: 'center',
    marginLeft: theme.spacing(),
  },
  avatar: {
    '@media print': {
      display: 'none',
    },
  },
}));

interface Props<T extends object> extends AutosuggestProps<T> {
  action?: CardHeaderProps['action'];
}

const AutosuggestCardHeader = <T extends object>({ action, ...inputProps }: Props<T>) => {
  const theme = useTheme();
  const { classes } = useStyles();

  return (
    <>
      <CardHeader
        classes={{
          action: classes.action,
          avatar: classes.avatar,
        }}
        action={<div>{action}</div>}
        avatar={
          <Avatar sx={{ backgroundColor: theme.palette.primary.main }}>
            <SearchIcon />
          </Avatar>
        }
        title={<AutosuggestChipInput {...inputProps} />}
      />
      <Divider />
    </>
  );
};

export default AutosuggestCardHeader;
